import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let breederrouter = new Router({
  routes: [{
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/help',
      name: 'help',
      component: () => import('./views/Help.vue'),
    },
    {
      path: '/analyze',
      name: 'analyze',
      component: () => import('./views/Analyze.vue'),
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('./views/Register.vue'),
    },
    {
      path: '/account',
      name: 'account',
      component: () => import('./views/Account.vue'),
    }
  ]
})

// 判断是否需要登录权限 以及是否登录
breederrouter.beforeEach((to, from, next) => {
  // 判断是否需要登录权限
  if (to.matched.some(res => res.meta.requireAuth)) {
    // 判断是否登录
    if (sessionStorage.getItem('token')) {
      next()
    } else {
      // 没登录则跳转到登录界面
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
})

export default breederrouter
